import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagedataComponent } from './managedata/managedata.component';
import {CategoryRoutingModule} from './category-routing.module';
import { Routes, RouterModule } from '@angular/router';
import {NgPipesModule} from 'ngx-pipes';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { ManageElementComponent } from './manage-element/manage-element.component';
import { ManageMappingComponent } from './manage-mapping/manage-mapping.component';
import { ProjectsComponent } from './projects/projects.component';
import { ViewCategoryComponent } from './view-category/view-category.component';
import { ViewBoqComponent } from './view-boq/view-boq.component';
import { ManageServicesComponent } from './manage-services/manage-services.component';
import { CategoryFloorplanComponent } from './category-floorplan/category-floorplan.component';
import { CategoryCadElevationComponent } from './category-cad-elevation/category-cad-elevation.component';
import { VendorComponent } from './vendor/vendor.component';
import { CollapsibleModule } from 'angular2-collapsible';
import { ShopDrawingComponent } from './shop-drawing/shop-drawing.component';
import { SdBoqComponent } from './sd-boq/sd-boq.component';
import { SdDrawingsComponent } from './sd-drawings/sd-drawings.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { CategoryProposalsComponent } from './category-proposals/category-proposals.component';
import { CategoryBoqComponent } from './category-boq/category-boq.component';
import { CategoryPptComponent } from './category-ppt/category-ppt.component';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { OrdersComponent } from './purchase-order/orders/orders.component';

@NgModule({
  imports: [
    CommonModule,
    CategoryRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule,
    NgPipesModule,
    AngularMultiSelectModule,
    CollapsibleModule,
    NgxPaginationModule
  ],
  declarations: [ManagedataComponent, ManageElementComponent, ManageMappingComponent, ProjectsComponent, ViewCategoryComponent, ViewBoqComponent, ManageServicesComponent, CategoryFloorplanComponent, CategoryCadElevationComponent, VendorComponent, ShopDrawingComponent, SdBoqComponent, SdDrawingsComponent, CategoryBoqComponent, CategoryPptComponent,CategoryProposalsComponent, PurchaseOrderComponent, OrdersComponent]
})
export class CategoryModule { }



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/category/category/category.module.ts